import React, { useRef, useState } from 'react';
// https://github.com/JustFly1984/react-google-maps-api
// https://react-google-maps-api-docs.netlify.app/
import { Autocomplete, LoadScript } from "@react-google-maps/api";
import PropTypes from "prop-types";

/*
 * https://developers.google.com/maps/documentation/places/web-service/autocomplete#maps_http_places_autocomplete_amoeba_strict-js
 */
const PlaceComponent = ({ value, onChange = () => {}, placeholder, disabled, onPlaceChanged, handlePlaceChanged }) => {
  const inputRef = useRef();
  const [ libraries ] = useState(['places']);

  let ip_based_location = '';
  if (placeholder && placeholder.city && placeholder.state) {
    ip_based_location = placeholder.city + ', ' + placeholder.state;
  }

  // https://developers.google.com/maps/documentation/javascript/place-autocomplete
  // https://developers.google.com/maps/documentation/javascript/supported_types
  const options = {
    componentRestrictions: { country: "us" },
    fields: ['address_components', 'formatted_address', 'geometry.location'],
    // types: ['(regions)'],  // to lock it to City/Town only (this isn't a great UX)
  };

  // Define the handler here, call prop if provided
  const handleAutocompleteChange = (autocompleteRef) => {
    if (autocompleteRef) {
      const place = autocompleteRef.getPlace();
      
      // Check if place is valid and has address components before proceeding
      if (!place || !place.address_components || place.address_components.length === 0) {
        console.log('No valid place selected or empty input, ignoring.');
        return;
      }
      
      // Now that we know we have a valid place, call the handlers
      if (onPlaceChanged) {
        onPlaceChanged(autocompleteRef);
      }
      
      // Also support handlePlaceChanged if provided
      if (handlePlaceChanged) {
        handlePlaceChanged(autocompleteRef);
      }
    }
    
    // Always call onChange with empty value to satisfy prop requirement
    onChange("");
  };

  return (
    <LoadScript
      googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
      libraries={libraries}
      preventGoogleFontsLoading
    >
      <Autocomplete
        onLoad={ref => inputRef.current = ref}
        onPlaceChanged={() => handleAutocompleteChange(inputRef.current)}
        options={options}
      >
        <input
          type="text"
          className="form-control"
          placeholder="Enter Location"
          defaultValue={ip_based_location}
          value={value}
          onChange={onChange}
          disabled={disabled}
        />
      </Autocomplete>
    </LoadScript>
  );
}

PlaceComponent.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      city: PropTypes.string,
      state: PropTypes.string
    })
  ]),
  disabled: PropTypes.bool,
  onPlaceChanged: PropTypes.func, // Optional, but recommended for parent integration
  handlePlaceChanged: PropTypes.func // Optional, newer API
};

export default PlaceComponent;
